"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.theme = exports.themeOptions = void 0;
var styles_1 = require("@mui/material/styles");
var colors_1 = require("@mui/material/colors");
var palette_1 = require("./palette");
var typography_1 = require("./typography");
exports.themeOptions = (0, styles_1.createTheme)({
    palette: __assign({}, palette_1.palette),
    typography: __assign({}, typography_1.typography),
    shape: {
        borderRadius: 8,
    },
    spacing: 8,
});
exports.theme = (0, styles_1.createTheme)(exports.themeOptions, {
    components: {
        MuiButton: {
            styleOverrides: {
                sizeLarge: __assign(__assign({}, exports.themeOptions.typography.h5), { letterSpacing: 2 }),
                sizeMedium: __assign(__assign({}, exports.themeOptions.typography.subtitle1), { letterSpacing: 1.5 }),
                sizeSmall: __assign(__assign({}, exports.themeOptions.typography.overline), { letterSpacing: 1.5 }),
                // eslint-disable-next-line
                root: function (_a) {
                    var ownerState = _a.ownerState;
                    var paletteKey = ownerState.color;
                    var palette = exports.themeOptions.palette[paletteKey];
                    return __assign({}, (ownerState.variant === "contained" && {
                        boxShadow: "0px 4px 16px ".concat(palette.main, "66"),
                    }));
                },
            },
        },
        MuiFab: {
            styleOverrides: {
                sizeLarge: __assign({}, exports.themeOptions.typography.h5),
                sizeMedium: __assign({}, exports.themeOptions.typography.subtitle1),
                sizeSmall: __assign({}, exports.themeOptions.typography.overline),
                // eslint-disable-next-line
                root: function (_a) {
                    var ownerState = _a.ownerState;
                    var paletteKey = ownerState.color;
                    var palette = exports.themeOptions.palette[paletteKey];
                    return __assign({
                        boxShadow: "0px 4px 16px ".concat(palette.main, "66"),
                    });
                },
            },
        },
        MuiFilledInput: {
            styleOverrides: {
                root: {
                    backgroundColor: exports.themeOptions.palette.background.default + " !important",
                    ":before": {
                        borderBottom: "2px solid ".concat(colors_1.grey[300]),
                    },
                    ":hover": {
                        borderBottom: "2px solid ".concat(colors_1.grey[300]),
                    },
                },
            },
        },
        MuiInputBase: {
            styleOverrides: {
                root: {
                    "& .MuiInputBase-input": {
                        paddingLeft: "8px !important",
                        paddingRight: "8px !important",
                    },
                },
            },
        },
        MuiInputLabel: {
            styleOverrides: {
                root: {
                    "&.Mui-focused": {
                        fontWeight: 600,
                    },
                },
            },
        },
        MuiGrid: {
            defaultProps: {
                rowSpacing: 2,
            },
            styleOverrides: {
                root: {
                    width: "100%",
                },
            },
        },
        MuiPaper: {
            styleOverrides: {
                root: {
                    // padding: '16px',
                    boxShadow: "0px 4px 16px ".concat(exports.themeOptions.palette.grey[500], "66"),
                },
            },
        },
        MuiAppBar: {
            styleOverrides: {
                root: {
                    color: exports.themeOptions.palette.grey[700],
                    backgroundColor: "transparent",
                    boxShadow: "none",
                    padding: "8px 16px",
                },
            },
        },
        MuiTable: {
            styleOverrides: {
                root: {
                    padding: "0",
                },
            },
        },
        MuiTableCell: {
            defaultProps: {
                align: "center",
            },
            styleOverrides: {
                root: {
                    color: "inherit",
                    textAlign: "center",
                    padding: 16,
                    borderBottom: "1px solid",
                    borderColor: exports.themeOptions.palette.grey["200"] + " !important",
                    "&.MuiTableCell-head": {
                        backgroundColor: colors_1.grey["200"] + " !important",
                    },
                },
            },
        },
        MuiTableHead: {
            styleOverrides: {
                root: {
                    color: exports.themeOptions.palette.primary.main,
                    borderBottom: "none",
                    letterSpacing: 1,
                    backgroundColor: colors_1.grey["200"] + " !important",
                },
            },
        },
        MuiTableSortLabel: {
            styleOverrides: {
                icon: {
                    color: exports.themeOptions.palette.primary.main,
                    fontWeight: 600,
                },
                iconDirectionAsc: {
                    color: exports.themeOptions.palette.primary.main,
                    fontWeight: 600,
                },
                iconDirectionDesc: {
                    color: exports.themeOptions.palette.primary.main,
                    fontWeight: 600,
                },
                root: {
                    color: exports.themeOptions.palette.primary.main,
                    fontWeight: 600,
                    "&:hover, &.Mui-active": {
                        color: "".concat(exports.themeOptions.palette.primary.dark, " !important"),
                    },
                    ".MuiTableSortLabel-icon": {
                        color: "inherit",
                    },
                },
            },
        },
        MuiSnackbarContent: {
            styleOverrides: {
                root: {
                    color: exports.themeOptions.palette.grey["800"],
                    backgroundColor: exports.themeOptions.palette.background.default,
                    indicator: {
                        backgroundColor: "black !important",
                    },
                },
            },
        },
        MuiTab: {
            styleOverrides: {
                root: {
                    color: exports.themeOptions.palette.grey["900"],
                    fontWeight: 600,
                    padding: "8px 24px",
                },
            },
        },
        MuiTabs: {
            styleOverrides: {
                root: {
                    backgroundColor: "#fff",
                    padding: "8px 16px",
                    ".MuiTabs-indicator": {
                        backgroundColor: exports.themeOptions.palette.secondary.main,
                    },
                },
            },
        },
        MuiListItem: {
            styleOverrides: {
                root: {
                    borderBottom: "1px solid",
                    borderColor: exports.themeOptions.palette.grey["200"] + " !important",
                },
            },
        },
        MuiRadio: {
            styleOverrides: {
                root: {
                    "&$checked": {
                        color: exports.themeOptions.palette.primary.main,
                    },
                },
                colorPrimary: {
                    "&$checked": {
                        color: exports.themeOptions.palette.primary.main,
                    },
                },
                colorSecondary: {
                    "&$checked": {
                        color: exports.themeOptions.palette.secondary.main,
                    },
                },
            },
        },
        MuiCheckbox: {
            styleOverrides: {
                colorPrimary: {
                    "&$checked": {
                        color: exports.themeOptions.palette.primary.main,
                    },
                },
                colorSecondary: {
                    "&$checked": {
                        color: exports.themeOptions.palette.secondary.main,
                    },
                },
            },
        },
        MuiCssBaseline: {
            styleOverrides: {
                "*": {
                    boxSizing: "border-box",
                    margin: 0,
                    padding: 0,
                    "*::-webkit-scrollbar, &::-webkit-scrollbar-thumb, *::-webkit-scrollbar-track": {
                        border: "5px solid transparent",
                        backgroundClip: "padding-box",
                        transition: "all 1s ease",
                    },
                    "*::-webkit-scrollbar": {
                        width: "1.2rem",
                    },
                    "*::-webkit-scrollbar-track": {
                        backgroundColor: "transparent",
                    },
                    "*::-webkit-scrollbar-thumb": {
                        borderRadius: "2rem",
                        backgroundColor: exports.themeOptions.palette.grey[500],
                    },
                    "*::-webkit-scrollbar:hover": {
                        borderRadius: "2rem",
                        backgroundColor: exports.themeOptions.palette.grey[300],
                    },
                    "*::-webkit-scrollbar-thumb:hover": {
                        width: "2rem",
                        backgroundColor: exports.themeOptions.palette.grey[700],
                    },
                },
                html: {
                    MozOsxFontSmoothing: "grayscale",
                    WebkitFontSmoothing: "antialiased",
                    display: "flex",
                    flexDirection: "column",
                    minHeight: "100%",
                    width: "100%",
                    margin: 0,
                },
                body: {
                    display: "flex",
                    flex: "1 1 auto",
                    flexDirection: "column",
                    minHeight: "100%",
                    width: "100%",
                    margin: "0",
                    overflowX: "hidden",
                },
                "#__next": {
                    display: "flex",
                    flex: "1 1 auto",
                    flexDirection: "column",
                    height: "100%",
                    width: "100%",
                    margin: "0",
                },
            },
        },
    },
});
//# sourceMappingURL=index.js.map